import { GET_QUESTIONS_LIST,GET_QUESTIONS_LIST_SUCCESS,GET_QUESTIONS_LIST_FAILED,GET_WORKFLOW_LIST,GET_WORKFLOW_LIST_SUCCESS,GET_WORKFLOW_LIST_FAILED,ADD_NEW_QUESTION,ADD_NEW_QUESTION_SUCCESS,ADD_NEW_QUESTION_FAILED,GET_QUESTION_DETAILS,GET_QUESTION_DETAILS_SUCCESS,GET_QUESTION_DETAILS_FAILED ,UPDATE_QUESTION_DETAILS,UPDATE_QUESTION_DETAILS_SUCCESS,UPDATE_QUESTION_DETAILS_FAILED, TOGGLE_QUESTION, TOGGLE_QUESTION_SUCCESS, TOGGLE_QUESTION_FAILED, GET_WORKFLOW_OPTIONS_LIST, GET_WORKFLOW_OPTIONS_LIST_SUCCESS,GET_WORKFLOW_OPTIONS_LIST_FAILED,ADD_NEW_WORKFLOW,ADD_NEW_WORKFLOW_SUCCESS,ADD_NEW_WORKFLOW_FAILED,UPDATE_WORKFLOW_DETAILS,UPDATE_WORKFLOW_DETAILS_SUCCESS,UPDATE_WORKFLOW_DETAILS_FAILED,GET_SAMPLE_CSV_QUESTION,GET_SAMPLE_CSV_QUESTION_SUCCESS,GET_SAMPLE_CSV_QUESTION_FAILED,GET_CSV_QUESTION_STATUS,GET_CSV_QUESTION_STATUS_SUCCESS,GET_CSV_QUESTION_STATUS_FAILED,BULK_IMPORT_QUESTIONS,BULK_IMPORT_QUESTIONS_SUCCESS,BULK_IMPORT_QUESTIONS_FAILED,DELETE_WORKFLOW,DELETE_WORKFLOW_SUCCESS,DELETE_WORKFLOW_FAILED} from "./actionTypes";

export const getQuestionsList=(obj)=>{
    return{
        type: GET_QUESTIONS_LIST,
      payload:obj
    }

}

export const getQuestionsListSuccess=(obj)=>{
    return{
        type: GET_QUESTIONS_LIST_SUCCESS,
      payload:obj
    }

}

export const getQuestionsListFailed=(obj)=>{
    return{
        type: GET_QUESTIONS_LIST_FAILED,
      payload:obj
    }

}

export const getWorkflowList=(obj)=>{
  return{
      type: GET_WORKFLOW_LIST,
    payload:obj
  }

}

export const getWorkflowListSuccess=(obj)=>{
  return{
      type: GET_WORKFLOW_LIST_SUCCESS,
    payload:obj
  }

}

export const getWorkflowListFailed=(obj)=>{
  return{
      type: GET_WORKFLOW_LIST_FAILED,
    payload:obj
  }

}

export const addNewQuestion=(data)=>{
  return{
    type:ADD_NEW_QUESTION,
    payload:data
  }
}

export const addNewQuestionSuccess=(data)=>{
  return{
    type:ADD_NEW_QUESTION_SUCCESS,
    payload:data
  }
}

export const addNewQuestionFailed=(error)=>{
  return{
    type:ADD_NEW_QUESTION_FAILED,
    payload:error
  }
}

export const getQuestionDetails=(data)=>{
  return{
    type:GET_QUESTION_DETAILS,
    payload:data
  }
}

export const getQuestionDetailsSuccess=(data)=>{
  return{
    type:GET_QUESTION_DETAILS_SUCCESS,
    payload:data
  }
}

export const getQuestionDetailsFailed=(error)=>{
  return{
    type:GET_QUESTION_DETAILS_FAILED,
    payload:error
  }
}

export const updateQuestionDetails=(data)=>{
  return{
    type:UPDATE_QUESTION_DETAILS,
    payload:data
  }
}

export const updateQuestionDetailsSuccess=(data)=>{
  return{
    type:UPDATE_QUESTION_DETAILS_SUCCESS,
    payload:data
  }
}

export const updateQuestionDetailsFailed=(error)=>{
  return{
    type:UPDATE_QUESTION_DETAILS_FAILED,
    payload:error
  }
}

export const toggleQuestion=(data)=>{
  return{
    type:TOGGLE_QUESTION,
    payload:data
  }
}

export const toggleQuestionSuccess=(data)=>{
  return{
    type:TOGGLE_QUESTION_SUCCESS,
    payload:data
  }
}

export const toggleQuestionFailed=(error)=>{
  return{
    type:TOGGLE_QUESTION_FAILED,
    payload:error
  }
}

export const getWorkFlowOptions=(data)=>{
  return{
    type:GET_WORKFLOW_OPTIONS_LIST,
    payload:data
  }
}

export const getWorkFlowOptionsSuccess=(data)=>{
  return{
    type:GET_WORKFLOW_OPTIONS_LIST_SUCCESS,
    payload:data
  }
}

export const getWorkFlowOptionsFailed=(error)=>{
  return{
    type:GET_WORKFLOW_OPTIONS_LIST_FAILED,
    payload:error
  }
}

export const addNewWorkflow=(data)=>{
  return{
    type:ADD_NEW_WORKFLOW,
    payload:data
  }

}

export const addNewWorkflowSuccess=(data)=>{
  return{
    type:ADD_NEW_WORKFLOW_SUCCESS,
    payload:data
  }

}

export const addNewWorkflowFailed=(error)=>{
  return{
    type:ADD_NEW_WORKFLOW_FAILED,
    payload:error
  }

}

export const updateWorkFlowDetails=(data)=>{
  return{
    type:UPDATE_WORKFLOW_DETAILS,
    payload:data
  }

}

export const updateWorkFlowDetailsSuccess=(data)=>{
  return{
    type:UPDATE_WORKFLOW_DETAILS_SUCCESS,
    payload:data
  }

}

export const updateWorkFlowDetailsFailed=(error)=>{
  return{
    type:UPDATE_WORKFLOW_DETAILS_FAILED,
    payload:error
  }

}

export const getSampleCsvQuestion=(data)=>{
  return{
    type:GET_SAMPLE_CSV_QUESTION,
    payload:data
  }

}

export const getSampleCsvQuestionSuccess=(data)=>{
  return{
    type:GET_SAMPLE_CSV_QUESTION_SUCCESS,
    payload:data
  }

}

export const getSampleCsvQuestionFailed=(error)=>{
  return{
    type:GET_SAMPLE_CSV_QUESTION_FAILED,
    payload:error
  }

}

export const getCsvQuestionStatus=(data)=>{
  return{
    type:GET_CSV_QUESTION_STATUS,
    payload:data
  }

}

export const getCsvQuestionStatusSuccess=(data)=>{
  return{
    type:GET_CSV_QUESTION_STATUS_SUCCESS,
    payload:data
  }

}

export const getCsvQuestionStatusFailed=(error)=>{
  return{
    type:GET_CSV_QUESTION_STATUS_FAILED,
    payload:error
  }

}

export const bulkImportQuestions=(data)=>{
  return{
    type:BULK_IMPORT_QUESTIONS,
    payload:data
  }

}

export const bulkImportQuestionsSuccess=(data)=>{
  return{
    type:BULK_IMPORT_QUESTIONS_SUCCESS,
    payload:data
  }

}

export const bulkImportQuestionsFailed=(error)=>{
  return{
    type:BULK_IMPORT_QUESTIONS_FAILED,
    payload:error
  }

}

export const deleteWorkflow=(data)=>{
  return{
    type:DELETE_WORKFLOW,
    payload:data
  }

}

export const deleteWorkflowSuccess=(data)=>{
  return{
    type:DELETE_WORKFLOW_SUCCESS,
    payload:data
  }

}

export const deleteWorkflowFailed=(error)=>{
  return{
    type:DELETE_WORKFLOW_FAILED,
    payload:error
  }

}

